import { IcepackStateCustomModalCell } from './components/icepack-state-custom-modal-cell';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const ICEPACK_STATE_FORM_NAME = 'icepack-state-form';

export const REQUIRED_FIELDS = ['name'];

export const FIELDS_FOR_VALIDATE = ['name'];

export const ICEPACK_STATE_TABLE_COLUMNS_NAMES = [
	{ id: 'title' },
	{ id: 'value', customComponent: IcepackStateCustomModalCell },
];

export const ICEPACK_STATE_TABLE_ROWS_NAMES = {
	author: 'Автор',
};
